import { Container, Stack } from "@mui/material";
import Contact from "../../components/Contact/Contact";
import theme from "../../muiTheme";

const ContactPage = () => {
  return (
    <Container>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        paddingY={{xs: 5, lg:10}}
        bgcolor={theme.palette.grey[50]}
      >
        <Contact />
      </Stack>
    </Container>
  );
};

export default ContactPage;